/** Display helpers shared by the request-list screens (match the Power App). */

/**
 * Format a stored datetime as "M/D/YYYY h:mm AM/PM" — matching how the Power App
 * shows CreatedDate. Reads the stored components as-is (no timezone shift), so the
 * displayed time is the same value already shown, just formatted. Handles ISO
 * ("2026-09-01T12:24:00.000Z"), SQL ("2026-09-01 12:24:00"), and the stray-colon
 * variant ("2026-09-01T12:24:00:000Z"). Falls back to the raw value if unparseable.
 */
export function fmtDateTime(v: unknown): string {
  if (v === null || v === undefined || v === '') return '';
  const m = String(v).match(/^(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{2}):(\d{2}))?/);
  if (!m) return String(v);
  const [, y, mo, d, hh, mi] = m;
  const date = `${parseInt(mo, 10)}/${parseInt(d, 10)}/${y}`;
  if (hh === undefined) return date; // date-only value (e.g. a completion date)
  let h = parseInt(hh, 10);
  const ampm = h >= 12 ? 'PM' : 'AM';
  h = h % 12 || 12;
  return `${date} ${h}:${mi} ${ampm}`;
}

/**
 * Single "Client/Sub ID" value like the Power App: the sub id when it's a real
 * sub, otherwise the client id.
 */
export function clientSubId(r: { ClientID?: unknown; ClientSubID?: unknown }): string {
  const id = String(r.ClientID ?? '');
  const sub = String(r.ClientSubID ?? '');
  return sub && sub !== '0' && sub !== id ? sub : id;
}
